<template>
  <v-card height="100%" class="dialog-cls no-card-shadow">
    <v-card-title class="dialog-title">
      Book an appointment
      <v-spacer></v-spacer>
      <v-icon color="rgba(47, 76, 103, 1)" @click="paymentConfirm = true"
        >close</v-icon
      >
    </v-card-title>
    <v-card-subtitle class="pt-3">
      <span class="payment-subtitle"
        >Enter payment details to request an appointment</span
      >
    </v-card-subtitle>
    <v-card-text class="py-5">
      <v-row>
        <v-col cols="12">
          <div class="type-select">Card number</div>
          <div class="field" id="card-Number">
            <!-- A Stripe Card Number Element will be inserted here. -->
          </div> </v-col
        ><v-col>
          <div class="type-select">Expiry date</div>
          <div class="field" id="card-Expiry">
            <!-- A Stripe Expiry date Element will be inserted here. -->
          </div>
        </v-col>
        <v-col>
          <div class="type-select">CVC/CVV</div>
          <div class="field" id="card-Cvc">
            <!-- A Stripe Element  CVC/CVV will be inserted here. -->
          </div>
        </v-col>
        <v-col cols="12">
          <!-- Used to display Element errors. -->
          <div id="cardNumber-errors" role="alert"></div>
          <div id="cardExpiry-errors" role="alert"></div>
          <div id="cardCvc-errors" role="alert"></div>
        </v-col>
      </v-row>
      <v-divider class="pt-3"></v-divider>
      <v-row>
        <v-col cols="12" class="payment-details-title">Payment details</v-col>
        <v-col cols="4" class="payment-text pb-0">Appointment Type :</v-col>
        <v-col cols="8" class="text-right payment-details pb-0">
          {{ selected.title }}
        </v-col>
        <v-col cols="4" class="payment-text">Doctor :</v-col>
        <v-col cols="8" class="text-right payment-details">
          {{ `${profile.firstName} ${profile.lastName}` }}
        </v-col>
        <v-col cols="4" class="payment-text pt-0">Date & Time :</v-col>
        <v-col cols="8" class="text-right payment-details pt-0">
          {{
            `${slotDetails.date}.  ${slotDetails.startTime} - ${slotDetails.endTime}`
          }}
        </v-col>
      </v-row>
      <div class="border-payment"></div>
      <v-row>
        <v-col cols="6" class="payment-text">
          Total fees :
        </v-col>
        <v-col cols="6" class="total-fees">
          <span class="payment-details">
            <span>£ {{ parseInt(selected.fees, 0) / 100 }}</span>
          </span>
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="d-flex justify-end py-4 px-4">
      <v-dialog v-model="paymentConfirm" persistent max-width="350">
        <template v-slot:activator="{ on, attrs }">
          <div>
            <v-btn
              text
              color="#6B6B6B"
              v-bind="attrs"
              v-on="on"
              class="cancle-btn text-transform"
            >
              Cancel
            </v-btn>
          </div>
        </template>
        <v-card class="dialog-cls">
          <v-card-title>
            <span class="dialog-title">Delete Request</span>
          </v-card-title>
          <v-card-text class="dialog-text">
            Are you sure you don't want to continue
            <strong color="red darken-1">booking</strong> ?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="paymentConfirm = false"
              >Disagree</v-btn
            >
            <v-btn color="green darken-1" text @click="cancelPayment"
              >Agree</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <div>
        <v-btn
          :loading="loading"
          color="#096DD8"
          class="text-transform"
          @click="doPayment"
        >
          Pay and request appointment
        </v-btn>
      </div>
      <div id="cardNumber-errors" role="alert"></div>
      <div id="cardExpiry-errors" role="alert"></div>
      <div id="cardCvc-errors" role="alert"></div>
      <div id="iframe-payment"></div>
    </v-card-actions>
  </v-card>
  <!-- <v-card>
      <v-list>
        <v-list-item>
          <v-content>
            <v-list-item-title class="book-appointment-title mt-3"
              >Book an appointment</v-list-item-title
            >
            <v-list-item-title class="payment-subtitle mt-2">
              Enter payment details to request an appointment
            </v-list-item-title> </v-content
          ><v-spacer></v-spacer
          ><v-list-item-icon
            ><v-icon color="rgba(47, 76, 103, 1)" @click="paymentModal = false"
              >close</v-icon
            ></v-list-item-icon
          ></v-list-item
        >
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" lg="12" sm="6">
                Card number
                <v-card-text class="mt-5">
                  <div class="form-row dialog-sub-title px-2">
                    <label for="card-element">Credit or debit card</label>
                    <div id="card-element">
                    </div>

                    <div id="card-errors" role="alert"></div>
                  </div>
                </v-card-text>
              </v-col>
              <v-col cols="12" lg="6" sm="6">
                Expiry Date
              </v-col>
              <v-col cols="12" lg="6" sm="6">
                CVV/CVC
              </v-col>
              <v-col cols="12">
                <v-checkbox>
                  <template v-slot:label>
                    <div>
                      Save card details for future use
                    </div>
                  </template> </v-checkbox
                ><v-divider></v-divider
              ></v-col>
              <v-row>
                <v-col cols="12"
                  ><v-list-item class="payment-details"
                    >Payment Details</v-list-item
                  ></v-col
                >
                <v-col cols="12" lg="6"
                  ><v-list-item>Appointment type</v-list-item>
                  <v-list-item>Doctor</v-list-item>
                  <v-list-item>Date & Time</v-list-item>
                </v-col>
                <v-col cols="12" lg="6">
                  <v-list-item> Regular check-up 30 minutes</v-list-item>
                  <v-list-item> Faruk Ljubovic, MD</v-list-item>
                  <v-list-item> 04.07.2022. 11:30 AM - 12:00 PM</v-list-item>
                </v-col>
              </v-row>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions style="position:absolute;bottom:30px;right:10px">
          <v-spacer></v-spacer>
          <v-btn style="margin-right:50px" text @click="paymentModal = false">
            Cancel
          </v-btn>
          <v-btn
            depressed
            color="primary"
            :loading="loading"
            @click="doPayment"
          >
            Pay and request appointment
          </v-btn>
        </v-card-actions>
      </v-list></v-card
    > -->
</template>

<script>
import { STRIPE_KEY } from "@/constants";
import { BookingService } from "@/services";
var stripe = new window.Stripe(STRIPE_KEY);
var elements = stripe.elements();
var style = {
  base: {
    // Add your base input styles here. For example:
    fontSize: "16px",
    color: "#32325d"
  }
};

export default {
  props: {
    profile: Object,
    bookingId: String,
    selected: Object,
    bookingDetails: Object,
    slotDetails: Object,
    isPaymentModal: Boolean,
    recurringBooking: Boolean
  },
  data() {
    return {
      paymentModal: false,
      paymentConfirm: false,
      loading: false,
      complete: false,
      cardNumber: {},
      cardExpiry: {},
      cardCvc: {},
      isBookingDone: false,
      stripe: STRIPE_KEY,
      options: {
        // see https://stripe.com/docs/stripe.js#element-options for details
      }
    };
  },
  mounted() {
    this.cardNumber = elements.create("cardNumber", {
      style: style,
      showIcon: true,
      placeholder: "0000 0000 0000 0000"
    });
    this.cardExpiry = elements.create("cardExpiry", {
      style: style
    });
    this.cardCvc = elements.create("cardCvc", { style: style });
    this.cardNumber.mount("#card-Number");
    this.cardExpiry.mount("#card-Expiry");
    this.cardCvc.mount("#card-Cvc");
  },
  beforeDestroy() {
    this.cardNumber.destroy("#card-Number");
    this.cardExpiry.destroy("#card-Expiry");
    this.cardCvc.destroy("#card-Cvc");
  },
  watch: {
    isPaymentModal() {
      if (this.isPaymentModal) {
        this.cardNumber.clear();
        this.cardExpiry.clear();
        this.cardCvc.clear();
      }
    }
  },
  methods: {
    bookingDone(id) {
      this.isBookingDone = true;
      this.bookingId = id;
    },
    cancelPayment() {
      this.paymentConfirm = false;
      this.loading = false;
      this.$emit("cancelPayment");
    },
    async doPayment() {
      this.paymentConfirm = false;
      this.loading = true;
      let token;
      try {
        token = await this.createToken();
      } catch (e) {
        // console.log("Error", e);
        this.loading = false;
        return;
      }
      let bookingResponse;
      if (this.recurringBooking) {
        bookingResponse = await BookingService.recurringBooking(
          this.$route.params.bookingId,
          this.bookingDetails
        );
      } else {
        bookingResponse = await BookingService.create(this.bookingDetails);
      }
      if (bookingResponse) {
        try {
          const bookingID = bookingResponse.data.id;
          const normalSource = await this.createNormalSource(token);
          if (
            (normalSource.card.three_d_secure === "not_supported" ||
              normalSource.card.three_d_secure === "optional") &&
            normalSource.status === "chargeable"
          ) {
            // console.log("Send to server.. 2", normalSource.id);
            const sourceResponse = await BookingService.sourcePayment({
              sourceId: normalSource.id,
              bookingId: bookingID
            });
            this.loading = false;
            if (sourceResponse) {
              this.$router.push({ name: "Bookings" });
            }
            // console.log(sourceResponse);
            return;
          } else if (normalSource.card.three_d_secure === "required") {
            const threedSource = await this.create3dSource(normalSource);
            // console.log("Send to server.. 3", threedSource.id);
            const sourceResponse = await BookingService.sourcePayment({
              sourceId: threedSource.id,
              bookingId: bookingID
            });
            this.loading = false;
            if (sourceResponse) {
              this.$router.push({ name: "Bookings" });
            }
            // console.log(sourceResponse);
          }
        } catch (e) {
          // console.log("Error", e);
          this.loading = false;
        }
      } else {
        this.cancelPayment();
      }
    },
    async createToken() {
      return new Promise(async (resolve, reject) => {
        try {
          const token = await stripe.createToken(this.cardNumber);
          if (token.error) {
            var errorElement = document.getElementById("cardNumber-errors");
            var errorElement1 = document.getElementById("cardExpiry-errors");
            var errorElement2 = document.getElementById("cardCvc-errors");
            if (errorElement) {
              errorElement.textContent = token.error.message;
              return reject(token.error.message);
            } else if (errorElement1) {
              errorElement1.textContent = token.error.message;
              return reject(token.error.message);
            } else if (errorElement2) {
              errorElement2.textContent = token.error.message;
              return reject(token.error.message);
            }
          }
          return resolve(token.token);
        } catch (e) {
          return reject(e);
        }
      });
    },
    async createNormalSource(token) {
      return new Promise(async (resolve, reject) => {
        try {
          const source = await stripe.createSource({
            type: "card",
            token: token.id,
            amount: 5000,
            currency: "gbp"
          });
          if (source.error) {
            return reject(source.error.message);
          }
          return resolve(source.source);
        } catch (e) {
          return reject(e);
        }
      });
    },
    async create3dSource(cardResponse) {
      return new Promise(async (resolve, reject) => {
        try {
          const source = await stripe.createSource({
            type: "three_d_secure",
            amount: 5000,
            currency: "gbp",
            three_d_secure: { card: cardResponse.id },
            redirect: { return_url: window.location.href }
          });
          if (source.error) {
            return reject(source.error.message);
          }
          if (cardResponse.card.three_d_secure === "required") {
            document.querySelector("#iframe-payment").innerHTML =
              '<iframe style="width:100%; height: 800px;" frameborder="0" src="' +
              source.source.redirect.url +
              '"></iframe>';
            const checkSourceStatus = await this.pollForSourceStatus({
              id: source.source.id,
              client_secret: source.source.client_secret
            });
            if (checkSourceStatus) {
              return resolve(source.source);
            } else {
              return reject("Payment cancelled.!");
            }
          } else {
            return resolve(source.source);
          }
        } catch (e) {
          return reject(e);
        }
      });
    },
    async pollForSourceStatus(obj) {
      return new Promise(async resolve => {
        const checkData = await stripe.retrieveSource(obj);
        const source = checkData.source;
        if (source.status === "chargeable") {
          this.$store.dispatch(
            "user/setSnack",
            "Success!!!! Your details are correct!!!"
          );
          this.$store.dispatch("user/setType", "info");
          return resolve(true);
        } else if (source.status === "canceled" || source.status === "failed") {
          document.querySelector("#iframe-payment").innerHTML = "Falied :)";
          return resolve(false);
        } else if (source.status === "pending") {
          return setTimeout(resolve(this.pollForSourceStatus(obj)), 5000);
        }
      });
    }
  }
};
</script>

<style scoped>
#cardNumber-errors,
#cardExpiry-errors,
#cardCvc-errors {
  font-family: Palanquin;
  font-style: normal;
  font-size: 15px;
  line-height: 130%;
  color: red;
  letter-spacing: 0.05em;
}
.stripe-card {
  padding: 15px;
}
.stripe-card.complete {
  border-color: green;
}
/* button {
  font-family: Palanquin dark;
  font-style: normal;
  line-height: 32px;
  border: 1px solid #344452;
  background-color: #344452;
  color: #ffffff;
  padding: 5px 10px;
  cursor: pointer;
  text-align: center;
  align-items: center;
  border-radius: 4px;
  font-weight: 500;
  letter-spacing: 0.0892857143em;
  justify-content: center;
  outline: 0;
  position: relative;
  text-decoration: none;
  text-indent: 0.0892857143em;
  text-transform: uppercase;
  width: 100%;
}
button:disabled,
button[disabled] {
  border: 1px solid #999999;
  background-color: #cccccc;
  color: rgba(0, 0, 0, 0.26) !important;
  text-transform: uppercase;
} */
.payment-subtitle {
  font-family: "Now Alt";
  font-size: 14px;
  font-weight: 300;
  color: #27445b;
}
.payment-details {
  font-family: "Now Alt";
  font-size: 14px;
  color: #27445b;
}
.payment-text {
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #27445b;
}
.total-fees {
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  text-align: right;
  color: #27445b;
}
.border-payment {
  border: 0.5px dashed #c5cdd6;
}
.text-transform {
  text-transform: initial !important;
  color: white;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
}
.cancle-btn {
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  margin-right: 16px;
}
.field {
  box-sizing: border-box;
  border: 1px solid #c5c5c5;
  border-radius: 6px;
  padding: 10px 20px 10px;
}
.type-select {
  font-family: "Now Alt";
  font-weight: 500;
  margin-bottom: 7px;
  font-size: 16px;
  color: #0c1f36;
}
.payment-details-title {
  font-family: "Now Alt";
  font-weight: 400;
  font-size: 16px;
  color: #27445b;
}
.no-card-shadow {
  box-shadow: none !important;
}
</style>
